import type { DecoSize, ShelfDecoKind } from './spine-utils.js';

const SIZE_PX: Record<DecoSize, Record<ShelfDecoKind, number>> = {
  md: {
    '🪴': 38,
    '🕯️': 28,
    '☕': 26,
    '🐈': 36,
    '🖼️': 28,
    '🌿': 26,
    '⭐': 22,
    '🍄': 28,
    '🌷': 30,
    '🏮': 32,
  },
  sm: {
    '🪴': 26,
    '🕯️': 20,
    '☕': 18,
    '🐈': 24,
    '🖼️': 20,
    '🌿': 18,
    '⭐': 16,
    '🍄': 20,
    '🌷': 22,
    '🏮': 22,
  },
};

interface ShelfDecorationProps {
  kind: ShelfDecoKind;
  size?: DecoSize;
}

export function ShelfDecoration({
  kind,
  size = 'md',
}: ShelfDecorationProps): JSX.Element {
  return (
    <span
      className={`shelf-deco shelf-deco-${size}`}
      style={{ fontSize: `${SIZE_PX[size][kind]}px` }}
      aria-hidden
    >
      {kind}
    </span>
  );
}
